import { frontendURL } from '../../../helper/URLHelper';
import AgentChatComparison from './pages/AgentChatComparison.vue';
import AgentCreate from './pages/AgentCreate.vue';
import AgentList from './pages/AgentsListView.vue';
import AgentIntelligentAdjustments from './pages/AgentIntelligentAdjustments.vue';
import AgentDetailView from './pages/AgentDetailView.vue';

const commonMeta = {
  permissions: ['administrator'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/agentis/test-environment'),
    name: 'agentis_test_environment',
    component: AgentChatComparison,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/agentis/create'),
    name: 'agentis_create',
    component: AgentCreate,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/agentis/list'),
    name: 'agentis_list',
    component: AgentList,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/agentis/adjustments'),
    name: 'agentis_adjustments',
    component: AgentIntelligentAdjustments,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/agentis/view/:agentId'),
    name: 'agentis_view',
    component: AgentDetailView,
    meta: commonMeta,
  }
];
